import { render, staticRenderFns } from "./UserRoleSelection.vue?vue&type=template&id=6028f671"
import script from "./UserRoleSelection.vue?vue&type=script&lang=js"
export * from "./UserRoleSelection.vue?vue&type=script&lang=js"
import style0 from "./UserRoleSelection.vue?vue&type=style&index=0&id=6028f671&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports